// import React, { useState } from "react";
// import axios from "axios";

// // ─── Types ────────────────────────────────────────────────────────────────────
// /**
//  * NOTE: TypeScript types are not supported in .jsx files and will throw errors.
//  * All below type/interface definitions are removed for correct behavior in JSX.
//  */

// // ─── Endpoint catalogue ───────────────────────────────────────────────────────
// const API_URL = process.env.REACT_APP_API_BASE;
// const GROUPS = [
//   {
//     group: "Webhooks",
//     color: "#6366f1",
//     endpoints: [
//       {
//         id: "get-webhook-url",
//         label: "Get webhook URL",
//         method: "GET",
//         path: `${API_URL}/auth/user/webhook-url`,
//         description: "Fetch the saved webhook URL for a phone number",
//         queryFields: [
//           { key: "phone_number_id", placeholder: "1234567890", required: true },
//           { key: "user_id", placeholder: "42", required: true },
//         ],
//       },
//       {
//         id: "save-webhook-url",
//         label: "Save webhook URL",
//         method: "POST",
//         path: `${API_URL}/auth/user/webhook-url`,
//         description: "Save or update your webhook endpoint URL",
//         bodyFields: [
//           { key: "phone_number_id", placeholder: "1234567890", required: true },
//           { key: "user_id", placeholder: "42", required: true },
//           { key: "webhook_url", placeholder: "https://your-server.com/webhook", required: true },
//         ],
//       },
//       {
//         id: "delete-webhook-url",
//         label: "Remove webhook URL",
//         method: "DELETE",
//         path: `${API_URL}/auth/user/webhook-url`,
//         description: "Clear the saved webhook URL",
//         bodyFields: [
//           { key: "phone_number_id", placeholder: "1234567890", required: true },
//           { key: "user_id", placeholder: "42", required: true },
//         ],
//       },
//       {
//         id: "test-webhook",
//         label: "Test webhook",
//         method: "POST",
//         path: `${API_URL}/auth/user/webhook-url/test`,
//         description: "Send a test payload to a webhook URL",
//         bodyFields: [
//           { key: "webhook_url", placeholder: "https://your-server.com/webhook", required: true },
//         ],
//       },
//       {
//         id: "save-webhook-secret",
//         label: "Save webhook secret",
//         method: "POST",
//         path: `${API_URL}/auth/user/webhook-secret`,
//         description: "Set the HMAC secret for signature verification",
//         bodyFields: [
//           { key: "phone_number_id", placeholder: "1234567890", required: true },
//           { key: "user_id", placeholder: "42", required: true },
//           { key: "webhook_secret", placeholder: "my_secret_key", required: true, type: "password" },
//         ],
//       },
//       {
//         id: "webhook-logs",
//         label: "Webhook logs",
//         method: "GET",
//         path: `${API_URL}/auth/user/webhook-logs`,
//         description: "Fetch delivery logs for a phone number",
//         queryFields: [
//           { key: "phone_number_id", placeholder: "1234567890", required: true },
//           { key: "user_id", placeholder: "42", required: true },
//         ],
//       },
//       {
//         id: "retry-webhook",
//         label: "Retry failed webhook",
//         method: "POST",
//         path: `${API_URL}/auth/user/webhook/retry`,
//         description: "Re-queue a failed webhook delivery by log ID",
//         bodyFields: [
//           { key: "log_id", placeholder: "7", required: true },
//         ],
//       },
//     ],
//   },
//   {
//     group: "Templates",
//     color: "#10b981",
//     endpoints: [
//       {
//         id: "list-templates",
//         label: "List templates",
//         method: "GET",
//         path: `${API_URL}/auth/templates/:wabaId`,
//         description: "Get all templates for a WABA (syncs with Meta)",
//         paramFields: [{ key: "wabaId", placeholder: "123456789" }],
//         bodyFields: [{ key: "access_token", placeholder: "Bearer token from Meta", required: true }],
//       },
//       {
//         id: "meta-templates",
//         label: "Meta templates (live)",
//         method: "GET",
//         path: `${API_URL}/auth/whatsapp/meta_templates`,
//         description: "Fetch & sync templates directly from Meta Graph API",
//         queryFields: [
//           { key: "waba_id", placeholder: "123456789", required: true },
//           { key: "access_token", placeholder: "Bearer token", required: true },
//         ],
//       },
//       {
//         id: "create-template",
//         label: "Create template",
//         method: "POST",
//         path: `${API_URL}/auth/templates/create`,
//         description: "Create a new WhatsApp message template",
//         bodyFields: [
//           { key: "waba_id", placeholder: "123456789", required: true },
//           { key: "name", placeholder: "my_template_name", required: true },
//           { key: "category", placeholder: "MARKETING", required: true },
//           { key: "language", placeholder: "en_US", required: true },
//           { key: "body_text", placeholder: "Hello {{1}}, your order {{2}} is ready!", required: true },
//           { key: "access_token", placeholder: "Bearer token", required: true },
//         ],
//       },
//       {
//         id: "create-template-advanced",
//         label: "Create template (advanced)",
//         method: "POST",
//         path: `${API_URL}/auth/create-template`,
//         description: "Create template with header, footer, buttons",
//         bodyFields: [
//           { key: "waba_id", placeholder: "123456789", required: true },
//           { key: "template_name", placeholder: "promo_oct", required: true },
//           { key: "language", placeholder: "en_US", required: true },
//           { key: "category", placeholder: "MARKETING", required: true },
//           { key: "body", placeholder: '{"text":"Hello {{1}}"}', required: true },
//           { key: "footer", placeholder: '{"text":"Reply STOP to unsubscribe"}' },
//         ],
//       },
//       {
//         id: "delete-template",
//         label: "Delete template",
//         method: "DELETE",
//         path: `${API_URL}/auth/template/delete`,
//         description: "Delete a template from Meta and local DB",
//         bodyFields: [
//           { key: "name", placeholder: "my_template_name", required: true },
//           { key: "waba_id", placeholder: "123456789", required: true },
//           { key: "access_token", placeholder: "Bearer token", required: true },
//         ],
//       },
//     ],
//   },
//   {
//     group: "Send Messages",
//     color: "#f59e0b",
//     endpoints: [
//       {
//         id: "send-text",
//         label: "Send text message",
//         method: "POST",
//         path: `${API_URL}/auth/send-message`,
//         description: "Send a plain text WhatsApp message",
//         bodyFields: [
//           { key: "phone_number_id", placeholder: "1234567890", required: true },
//           { key: "to", placeholder: "919876543210", required: true },
//           { key: "message", placeholder: "Hello from GlobeWA!", required: true },
//           { key: "access_token", placeholder: "Bearer token", required: true },
//         ],
//       },
//       {
//         id: "send-template-msg",
//         label: "Send template message",
//         method: "POST",
//         path: `${API_URL}/auth/messages/send-template`,
//         description: "Send an approved template message with variables",
//         bodyFields: [
//           { key: "phone_number_id", placeholder: "1234567890", required: true },
//           { key: "to", placeholder: "919876543210", required: true },
//           { key: "template_name", placeholder: "my_template_name", required: true },
//           { key: "variables", placeholder: '["John","Order #1234"]' },
//         ],
//       },
//     ],
//   },
//   {
//     group: "WhatsApp Accounts",
//     color: "#ec4899",
//     endpoints: [
//       {
//         id: "my-whatsapp",
//         label: "My WhatsApp accounts",
//         method: "GET",
//         path: `${API_URL}/auth/my-whatsapp`,
//         description: "Fetch all connected WABA accounts for the logged-in user",
//       },
//       {
//         id: "phone-numbers",
//         label: "Phone numbers",
//         method: "GET",
//         path: `${API_URL}/auth/user/whatsapp-phone-numbers/:userId`,
//         description: "Get all phone numbers for a user",
//         paramFields: [{ key: "userId", placeholder: "42" }],
//       },
//       {
//         id: "waba-phones",
//         label: "WABA phone numbers (live)",
//         method: "GET",
//         path: `${API_URL}/auth/waba/:wabaId/phones`,
//         description: "Fetch live phone numbers from Meta for a WABA",
//         paramFields: [{ key: "wabaId", placeholder: "123456789" }],
//       },
//       {
//         id: "waba-ids",
//         label: "WABA IDs for user",
//         method: "GET",
//         path: `${API_URL}/auth/whatsapp/waba_ids`,
//         description: "Get all WABA IDs associated with a user",
//         queryFields: [{ key: "user_id", placeholder: "42", required: true }],
//       },
//       {
//         id: "message-limit",
//         label: "Message limit",
//         method: "GET",
//         path: `${API_URL}/auth/message-limit`,
//         description: "Check WhatsApp Business messaging tier limits",
//         queryFields: [
//           { key: "phone_number_id", placeholder: "1234567890", required: true },
//           { key: "fbToken", placeholder: "Bearer token", required: true },
//         ],
//       },
//     ],
//   },
//   {
//     group: "Conversations",
//     color: "#06b6d4",
//     endpoints: [
//       {
//         id: "conversations",
//         label: "List conversations",
//         method: "GET",
//         path: `${API_URL}/auth/conversation/:phoneNumberId`,
//         description: "Get all conversation threads for a phone number",
//         paramFields: [{ key: "phoneNumberId", placeholder: "1234567890" }],
//       },
//       {
//         id: "messages",
//         label: "Get messages",
//         method: "GET",
//         path: `${API_URL}/auth/messages/:phoneNumberId/:userNumber`,
//         description: "Get message history for a specific conversation",
//         paramFields: [
//           { key: "phoneNumberId", placeholder: "1234567890" },
//           { key: "userNumber", placeholder: "919876543210" },
//         ],
//       },
//       {
//         id: "window-status",
//         label: "Window status",
//         method: "GET",
//         path: `${API_URL}/auth/window-status`,
//         description: "Check if the 24hr messaging window is open",
//         queryFields: [
//           { key: "phone_number_id", placeholder: "1234567890", required: true },
//           { key: "customer_number", placeholder: "919876543210", required: true },
//         ],
//       },
//       {
//         id: "mark-read",
//         label: "Mark as read",
//         method: "POST",
//         path: `${API_URL}/auth/mark-read`,
//         description: "Mark all messages from a number as read",
//         bodyFields: [{ key: "userNumber", placeholder: "919876543210", required: true }],
//       },
//     ],
//   },
// ];

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// const METHOD_COLORS = {
//   GET: "#10b981",
//   POST: "#6366f1",
//   PUT: "#f59e0b",
//   DELETE: "#ef4444",
// };

// function statusClass(code) {
//   if (code >= 200 && code < 300) return "2xx";
//   if (code >= 400 && code < 500) return "4xx";
//   if (code >= 500) return "5xx";
//   return "none";
// }

// function statusColor(cls) {
//   return { "2xx": "#10b981", "4xx": "#f59e0b", "5xx": "#ef4444", pending: "#6366f1", none: "#6b7280" }[cls];
// }

// function buildUrl(path, params, query) {
//   let url = path;
//   for (const [k, v] of Object.entries(params)) {
//     url = url.replace(`:${k}`, encodeURIComponent(v));
//   }
//   const qs = new URLSearchParams(Object.fromEntries(Object.entries(query).filter(([, v]) => v !== undefined && v !== null && v !== ""))).toString();
//   return qs ? `${url}?${qs}` : url;
// }

// // ─── Component ────────────────────────────────────────────────────────────────
// export default function ApiPlayground() {
//   const [selected, setSelected] = useState(GROUPS[0].endpoints[0]);
//   const [bodyValues, setBodyValues] = useState({});
//   const [queryValues, setQueryValues] = useState({});
//   const [paramValues, setParamValues] = useState({});
//   const [rawBody, setRawBody] = useState("");
//   const [useRaw, setUseRaw] = useState(false);
//   const [response, setResponse] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [activeResponseTab, setActiveResponseTab] = useState("body");
//   const [history, setHistory] = useState([]);
//   const [sidebarSearch, setSidebarSearch] = useState("");
//   const [expandedGroups, setExpandedGroups] = useState(new Set(GROUPS.map(g => g.group)));

//   // Added: user token capability
//   const [useUserToken, setUseUserToken] = useState(false);
//   const [userToken, setUserToken] = useState("");

//   function selectEndpoint(ep) {
//     setSelected(ep);
//     setBodyValues({});
//     setQueryValues({});
//     setParamValues({});
//     setRawBody("");
//     setResponse(null);
//   }

//   function toggleGroup(g) {
//     setExpandedGroups(prev => {
//       const next = new Set(prev);
//       next.has(g) ? next.delete(g) : next.add(g);
//       return next;
//     });
//   }

//   const filteredGroups = GROUPS.map(g => ({
//     ...g,
//     endpoints: g.endpoints.filter(e =>
//       e.label.toLowerCase().includes(sidebarSearch.toLowerCase()) ||
//       e.path.toLowerCase().includes(sidebarSearch.toLowerCase())
//     ),
//   })).filter(g => g.endpoints.length > 0);

//   async function send() {
//     setLoading(true);
//     setResponse(null);
//     const start = Date.now();
//     const url = buildUrl(selected.path, paramValues, queryValues);

//     let body = undefined;
//     if (selected.method !== "GET") {
//       if (useRaw) {
//         try { body = JSON.parse(rawBody); } catch { body = rawBody; }
//       } else {
//         body = Object.fromEntries(
//           Object.entries(bodyValues).map(([k, v]) => {
//             if (typeof v === "string") {
//               try { return [k, JSON.parse(v)]; } catch { return [k, v]; }
//             }
//             return [k, v];
//           })
//         );
//       }
//     }

//     let headers = {};
//     if (useUserToken && userToken) {
//       headers["Authorization"] = userToken.startsWith("Bearer ") ? userToken : `Bearer ${userToken}`;
//     }

//     try {
//       const res = await axios({
//         method: selected.method.toLowerCase(),
//         url,
//         data: body,
//         withCredentials: true,
//         headers,
//       });
//       const latency = Date.now() - start;
//       const resp = {
//         status: res.status,
//         statusText: res.statusText,
//         data: res.data,
//         latency,
//         headers: res.headers,
//       };
//       setResponse(resp);
//       setHistory(h => [{ endpoint: selected.label, status: res.status, latency, time: new Date().toLocaleTimeString() }, ...h.slice(0, 19)]);
//     } catch (err) {
//       const latency = Date.now() - start;
//       let errResp = err && err.response;
//       const resp = {
//         status: errResp && errResp.status ? errResp.status : 0,
//         statusText: (errResp && errResp.statusText) || "Network Error",
//         data: (errResp && errResp.data) || { error: (err && err.message) || "Unknown error" },
//         latency,
//         headers: (errResp && errResp.headers) || {},
//       };
//       setResponse(resp);
//       setHistory(h => [{ endpoint: selected.label, status: resp.status, latency, time: new Date().toLocaleTimeString() }, ...h.slice(0, 19)]);
//     }
//     setLoading(false);
//   }

//   const resolvedUrl = buildUrl(selected.path, paramValues, queryValues);

//   return (
//     <div style={{ display: "flex", height: "100vh", background: "#0a0a0f", fontFamily: "'JetBrains Mono', 'Fira Code', monospace", color: "#e2e8f0", overflow: "hidden" }}>

//       {/* ── Sidebar ── */}
//       <div style={{ width: 280, background: "#0f0f1a", borderRight: "1px solid #1e1e2e", display: "flex", flexDirection: "column", flexShrink: 0 }}>
//         <div style={{ padding: "16px 12px 12px", borderBottom: "1px solid #1e1e2e" }}>
//           <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
//             <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#6366f1" }} />
//             <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: "0.05em", color: "#a5b4fc" }}>API PLAYGROUND</span>
//           </div>
//           <input
//             value={sidebarSearch}
//             onChange={e => setSidebarSearch(e.target.value)}
//             placeholder="Search endpoints..."
//             style={{ width: "100%", background: "#1a1a2e", border: "1px solid #2a2a3e", borderRadius: 6, padding: "6px 10px", fontSize: 12, color: "#e2e8f0", outline: "none", boxSizing: "border-box" }}
//           />
//         </div>

//         <div style={{ flex: 1, overflowY: "auto", padding: "8px 0" }}>
//           {filteredGroups.map(g => (
//             <div key={g.group}>
//               <button
//                 onClick={() => toggleGroup(g.group)}
//                 style={{ width: "100%", display: "flex", alignItems: "center", gap: 8, padding: "6px 12px", background: "none", border: "none", cursor: "pointer", color: "#94a3b8", fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", fontFamily: "inherit" }}
//               >
//                 <div style={{ width: 6, height: 6, borderRadius: "50%", background: g.color, flexShrink: 0 }} />
//                 {g.group}
//                 <span style={{ marginLeft: "auto", fontSize: 10 }}>{expandedGroups.has(g.group) ? "▾" : "▸"}</span>
//               </button>
//               {expandedGroups.has(g.group) && g.endpoints.map(ep => (
//                 <button
//                   key={ep.id}
//                   onClick={() => selectEndpoint(ep)}
//                   style={{
//                     width: "100%", display: "flex", alignItems: "center", gap: 8, padding: "7px 12px 7px 24px",
//                     background: selected.id === ep.id ? "#1a1a2e" : "none",
//                     border: "none", borderLeft: selected.id === ep.id ? `2px solid ${g.color}` : "2px solid transparent",
//                     cursor: "pointer", fontFamily: "inherit",
//                   }}
//                 >
//                   <span style={{ fontSize: 10, fontWeight: 700, color: METHOD_COLORS[ep.method], minWidth: 36, textAlign: "left" }}>{ep.method}</span>
//                   <span style={{ fontSize: 11, color: selected.id === ep.id ? "#e2e8f0" : "#94a3b8", textAlign: "left", lineHeight: 1.3 }}>{ep.label}</span>
//                 </button>
//               ))}
//             </div>
//           ))}
//         </div>

//         {/* History */}
//         {history.length > 0 && (
//           <div style={{ borderTop: "1px solid #1e1e2e", padding: "8px 0" }}>
//             <div style={{ padding: "4px 12px 6px", fontSize: 10, fontWeight: 700, color: "#64748b", letterSpacing: "0.08em", textTransform: "uppercase" }}>Recent</div>
//             {history.slice(0, 5).map((h, i) => (
//               <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 12px", fontSize: 10, color: "#64748b" }}>
//                 <span style={{ color: statusColor(statusClass(h.status)), fontWeight: 700 }}>{h.status || "ERR"}</span>
//                 <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{h.endpoint}</span>
//                 <span style={{ color: "#475569" }}>{h.latency}ms</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* ── Main ── */}
//       <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>

//         {/* URL bar */}
//         <div style={{ padding: "12px 16px", borderBottom: "1px solid #1e1e2e", background: "#0c0c17" }}>
//           <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
//             <span style={{ fontSize: 11, color: "#64748b" }}>{selected.description}</span>
//           </div>
//           <div style={{ display: "flex", gap: 8 }}>
//             <div style={{ display: "flex", alignItems: "center", padding: "0 12px", background: "#1a1a2e", borderRadius: 8, border: "1px solid #2a2a3e", height: 40, minWidth: 80 }}>
//               <span style={{ fontSize: 12, fontWeight: 800, color: METHOD_COLORS[selected.method] }}>{selected.method}</span>
//             </div>
//             <div style={{ flex: 1, display: "flex", alignItems: "center", background: "#1a1a2e", borderRadius: 8, border: "1px solid #2a2a3e", padding: "0 12px", height: 40, overflow: "hidden" }}>
//               <span style={{ fontSize: 12, color: "#64748b", whiteSpace: "nowrap" }}>localhost /</span>
//               <span style={{ fontSize: 12, color: "#a5b4fc", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{resolvedUrl}</span>
//             </div>
//             <button
//               onClick={send} disabled={loading}
//               style={{ padding: "0 24px", height: 40, background: loading ? "#3730a3" : "#4f46e5", color: "white", border: "none", borderRadius: 8, cursor: loading ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 700, fontFamily: "inherit", display: "flex", alignItems: "center", gap: 8, transition: "background 0.15s" }}
//             >
//               {loading ? (
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ animation: "spin 0.8s linear infinite" }}><path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0"/></svg>
//               ) : (
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M5 3l14 9-14 9V3z"/></svg>
//               )}
//               {loading ? "Sending..." : "Send"}
//             </button>
//           </div>
//           {/* User Token Option (displayed below the URL/send bar) */}
//           <div style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 10 }}>
//             <label style={{ fontSize: 11, color: "#94a3b8", display: "flex", alignItems: "center", gap: 4 }}>
//               <input
//                 type="checkbox"
//                 checked={useUserToken}
//                 onChange={e => setUseUserToken(e.target.checked)}
//                 style={{ accentColor: "#6366f1", marginRight: 4 }}
//               />
//               Add Authorization token
//             </label>
//             {useUserToken && (
//               <input
//                 type="text"
//                 placeholder='e.g. Bearer ...'
//                 value={userToken}
//                 onChange={e => setUserToken(e.target.value)}
//                 style={{
//                   flex: 1, minWidth: 160,
//                   background: "#1a1a2e",
//                   border: "1px solid #2a2a3e",
//                   borderRadius: 6,
//                   padding: "6px 10px",
//                   fontSize: 12,
//                   color: "#e2e8f0",
//                   outline: "none",
//                   boxSizing: "border-box"
//                 }}
//               />
//             )}
//           </div>
//         </div>

//         {/* Request / Response panels */}
//         <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>

//           {/* Request */}
//           <div style={{ width: "45%", borderRight: "1px solid #1e1e2e", display: "flex", flexDirection: "column", overflow: "hidden" }}>
//             <div style={{ padding: "10px 16px", borderBottom: "1px solid #1e1e2e", display: "flex", alignItems: "center", gap: 12 }}>
//               <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.06em" }}>REQUEST</span>
//               {selected.method !== "GET" && (
//                 <div style={{ display: "flex", gap: 4, marginLeft: "auto" }}>
//                   {["Form", "Raw JSON"].map(t => (
//                     <button key={t} onClick={() => setUseRaw(t === "Raw JSON")}
//                       style={{ padding: "2px 10px", fontSize: 10, fontWeight: 600, background: (t === "Raw JSON") === useRaw ? "#1e1e2e" : "none", color: (t === "Raw JSON") === useRaw ? "#a5b4fc" : "#475569", border: "1px solid", borderColor: (t === "Raw JSON") === useRaw ? "#3730a3" : "transparent", borderRadius: 4, cursor: "pointer", fontFamily: "inherit" }}>
//                       {t}
//                     </button>
//                   ))}
//                 </div>
//               )}
//             </div>

//             <div style={{ flex: 1, overflowY: "auto", padding: 16 }}>

//               {/* Path params */}
//               {selected.paramFields && selected.paramFields.length > 0 && (
//                 <Section label="PATH PARAMS" color="#f59e0b">
//                   {selected.paramFields.map(f => (
//                     <Field key={f.key} label={f.key} placeholder={f.placeholder}
//                       value={paramValues[f.key] || ""} onChange={v => setParamValues(p => ({ ...p, [f.key]: v }))} />
//                   ))}
//                 </Section>
//               )}

//               {/* Query params */}
//               {selected.queryFields && selected.queryFields.length > 0 && (
//                 <Section label="QUERY PARAMS" color="#06b6d4">
//                   {selected.queryFields.map(f => (
//                     <Field key={f.key} label={f.key} placeholder={f.placeholder} required={f.required}
//                       value={queryValues[f.key] || ""} onChange={v => setQueryValues(p => ({ ...p, [f.key]: v }))} />
//                   ))}
//                 </Section>
//               )}

//               {/* Body */}
//               {selected.method !== "GET" && (
//                 <Section label="BODY" color="#10b981">
//                   {useRaw ? (
//                     <textarea
//                       value={rawBody}
//                       onChange={e => setRawBody(e.target.value)}
//                       placeholder='{"key": "value"}'
//                       rows={12}
//                       style={{ width: "100%", background: "#0f0f1a", border: "1px solid #1e1e2e", borderRadius: 6, padding: "10px 12px", fontSize: 12, color: "#a5b4fc", fontFamily: "inherit", resize: "vertical", outline: "none", boxSizing: "border-box" }}
//                     />
//                   ) : (
//                     selected.bodyFields && selected.bodyFields.map(f => (
//                       <Field key={f.key} label={f.key} placeholder={f.placeholder} required={f.required} type={f.type}
//                         value={bodyValues[f.key] || ""} onChange={v => setBodyValues(p => ({ ...p, [f.key]: v }))} />
//                     ))
//                   )}
//                 </Section>
//               )}

//               {(!selected.paramFields || !selected.paramFields.length) && (!selected.queryFields || !selected.queryFields.length) && selected.method === "GET" && (
//                 <div style={{ color: "#475569", fontSize: 12, padding: "40px 0", textAlign: "center" }}>No parameters required</div>
//               )}
//             </div>
//           </div>

//           {/* Response */}
//           <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
//             <div style={{ padding: "10px 16px", borderBottom: "1px solid #1e1e2e", display: "flex", alignItems: "center", gap: 12 }}>
//               <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.06em" }}>RESPONSE</span>
//               {response && (
//                 <>
//                   <span style={{ padding: "2px 8px", borderRadius: 4, fontSize: 11, fontWeight: 700, background: statusColor(statusClass(response.status)) + "22", color: statusColor(statusClass(response.status)), border: `1px solid ${statusColor(statusClass(response.status))}44` }}>
//                     {response.status} {response.statusText}
//                   </span>
//                   <span style={{ fontSize: 11, color: "#475569" }}>{response.latency}ms</span>
//                   <div style={{ display: "flex", gap: 4, marginLeft: "auto" }}>
//                     {["body", "headers"].map(t => (
//                       <button key={t} onClick={() => setActiveResponseTab(t)}
//                         style={{ padding: "2px 10px", fontSize: 10, fontWeight: 600, background: activeResponseTab === t ? "#1e1e2e" : "none", color: activeResponseTab === t ? "#a5b4fc" : "#475569", border: "1px solid", borderColor: activeResponseTab === t ? "#3730a3" : "transparent", borderRadius: 4, cursor: "pointer", fontFamily: "inherit", textTransform: "capitalize" }}>
//                         {t}
//                       </button>
//                     ))}
//                   </div>
//                 </>
//               )}
//             </div>

//             <div style={{ flex: 1, overflowY: "auto", padding: 16 }}>
//               {loading && (
//                 <div style={{ display: "flex", alignItems: "center", gap: 12, color: "#475569", padding: "40px 0" }}>
//                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2.5" style={{ animation: "spin 0.8s linear infinite" }}><path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0"/></svg>
//                   <span style={{ fontSize: 13 }}>Waiting for response...</span>
//                 </div>
//               )}
//               {!loading && !response && (
//                 <div style={{ color: "#334155", fontSize: 13, padding: "60px 0", textAlign: "center" }}>
//                   <div style={{ fontSize: 32, marginBottom: 12 }}>⚡</div>
//                   Hit Send to see the response
//                 </div>
//               )}
//               {!loading && response && (
//                 activeResponseTab === "body" ? (
//                   <pre style={{ fontSize: 12, color: "#a5b4fc", lineHeight: 1.6, margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
//                     {JSON.stringify(response.data, null, 2)}
//                   </pre>
//                 ) : (
//                   <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//                     {Object.entries(response.headers).map(([k, v]) => (
//                       <div key={k} style={{ display: "flex", gap: 12, fontSize: 12 }}>
//                         <span style={{ color: "#6366f1", minWidth: 180 }}>{k}</span>
//                         <span style={{ color: "#94a3b8" }}>{String(v)}</span>
//                       </div>
//                     ))}
//                   </div>
//                 )
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       <style>{`
//         @keyframes spin { to { transform: rotate(360deg); } }
//         ::-webkit-scrollbar { width: 4px; height: 4px; }
//         ::-webkit-scrollbar-track { background: transparent; }
//         ::-webkit-scrollbar-thumb { background: #1e1e2e; border-radius: 4px; }
//       `}</style>
//     </div>
//   );
// }

// // ─── Sub-components ───────────────────────────────────────────────────────────
// function Section({ label, color, children }) {
//   return (
//     <div style={{ marginBottom: 20 }}>
//       <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 10 }}>
//         <div style={{ width: 3, height: 12, background: color, borderRadius: 2 }} />
//         <span style={{ fontSize: 10, fontWeight: 700, color: "#64748b", letterSpacing: "0.08em" }}>{label}</span>
//       </div>
//       <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>{children}</div>
//     </div>
//   );
// }

// function Field({ label, placeholder, value, onChange, required, type }) {
//   return (
//     <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//       <div style={{ width: 140, flexShrink: 0, display: "flex", alignItems: "center", gap: 4 }}>
//         <span style={{ fontSize: 11, color: "#94a3b8", fontFamily: "inherit" }}>{label}</span>
//         {required && <span style={{ fontSize: 10, color: "#ef4444" }}>*</span>}
//       </div>
//       <input
//         type={type || "text"}
//         value={value}
//         onChange={e => onChange(e.target.value)}
//         placeholder={placeholder}
//         style={{ flex: 1, background: "#0f0f1a", border: "1px solid #1e1e2e", borderRadius: 6, padding: "6px 10px", fontSize: 12, color: "#e2e8f0", fontFamily: "inherit", outline: "none", transition: "border-color 0.15s" }}
//         onFocus={e => (e.target.style.borderColor = "#3730a3")}
//         onBlur={e => (e.target.style.borderColor = "#1e1e2e")}
//       />
//     </div>
//   );
// }


import React, { useState, useEffect } from "react";
import axios from "axios";

// ─── Token helpers ────────────────────────────────────────────────────────────
function decodeToken(token) {
  if (!token) return {};
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(
      decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      )
    );
  } catch {
    return {};
  }
}

function getUserIdFromToken() {
  const rawToken =
    typeof window !== 'undefined'
      ? localStorage.getItem('token')
      : null;
  if (rawToken) {
    const decoded = decodeToken(rawToken);
    return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
  }
  return { userId: null, token: null };
}

// ─── Endpoint catalogue ───────────────────────────────────────────────────────
const API_URL = process.env.REACT_APP_API_BASE;
const GROUPS = [
  {
    group: "Webhooks",
    color: "#6366f1",
    endpoints: [
      {
        id: "get-webhook-url",
        label: "Get webhook URL",
        method: "GET",
        path: `${API_URL}/auth/user/webhook-url`,
        description: "Fetch the saved webhook URL for a phone number",
        queryFields: [
          { key: "phone_number_id", placeholder: "1234567890", required: true },
          { key: "user_id", placeholder: "42", required: true, autoFromToken: true },
        ],
      },
      {
        id: "save-webhook-url",
        label: "Save webhook URL",
        method: "POST",
        path: `${API_URL}/auth/user/webhook-url`,
        description: "Save or update your webhook endpoint URL",
        bodyFields: [
          { key: "phone_number_id", placeholder: "1234567890", required: true },
          { key: "user_id", placeholder: "42", required: true, autoFromToken: true },
          { key: "webhook_url", placeholder: "https://your-server.com/webhook", required: true },
        ],
      },
      {
        id: "delete-webhook-url",
        label: "Remove webhook URL",
        method: "DELETE",
        path: `${API_URL}/auth/user/webhook-url`,
        description: "Clear the saved webhook URL",
        bodyFields: [
          { key: "phone_number_id", placeholder: "1234567890", required: true },
          { key: "user_id", placeholder: "42", required: true, autoFromToken: true },
        ],
      },
      {
        id: "test-webhook",
        label: "Test webhook",
        method: "POST",
        path: `${API_URL}/auth/user/webhook-url/test`,
        description: "Send a test payload to a webhook URL",
        bodyFields: [
          { key: "webhook_url", placeholder: "https://your-server.com/webhook", required: true },
        ],
      },
      {
        id: "save-webhook-secret",
        label: "Save webhook secret",
        method: "POST",
        path: `${API_URL}/auth/user/webhook-secret`,
        description: "Set the HMAC secret for signature verification",
        bodyFields: [
          { key: "phone_number_id", placeholder: "1234567890", required: true },
          { key: "user_id", placeholder: "42", required: true, autoFromToken: true },
          { key: "webhook_secret", placeholder: "my_secret_key", required: true, type: "password" },
        ],
      },
      {
        id: "webhook-logs",
        label: "Webhook logs",
        method: "GET",
        path: `${API_URL}/auth/user/webhook-logs`,
        description: "Fetch delivery logs for a phone number",
        queryFields: [
          { key: "phone_number_id", placeholder: "1234567890", required: true },
          { key: "user_id", placeholder: "42", required: true, autoFromToken: true },
        ],
      },
      {
        id: "retry-webhook",
        label: "Retry failed webhook",
        method: "POST",
        path: `${API_URL}/auth/user/webhook/retry`,
        description: "Re-queue a failed webhook delivery by log ID",
        bodyFields: [
          { key: "log_id", placeholder: "7", required: true },
        ],
      },
    ],
  },
  {
    group: "Templates",
    color: "#10b981",
    endpoints: [
      {
        id: "list-templates",
        label: "List templates",
        method: "GET",
        path: `${API_URL}/auth/templates/:wabaId`,
        description: "Get all templates for a WABA (syncs with Meta)",
        paramFields: [{ key: "wabaId", placeholder: "123456789" }],
        bodyFields: [{ key: "access_token", placeholder: "Bearer token from Meta", required: true }],
      },
      {
        id: "meta-templates",
        label: "Meta templates (live)",
        method: "GET",
        path: `${API_URL}/auth/whatsapp/meta_templates`,
        description: "Fetch & sync templates directly from Meta Graph API",
        queryFields: [
          { key: "waba_id", placeholder: "123456789", required: true },
          { key: "access_token", placeholder: "Bearer token", required: true },
        ],
      },
      {
        id: "create-template",
        label: "Create template",
        method: "POST",
        path: `${API_URL}/auth/templates/create`,
        description: "Create a new WhatsApp message template",
        bodyFields: [
          { key: "waba_id", placeholder: "123456789", required: true },
          { key: "name", placeholder: "my_template_name", required: true },
          { key: "category", placeholder: "MARKETING", required: true },
          { key: "language", placeholder: "en_US", required: true },
          { key: "body_text", placeholder: "Hello {{1}}, your order {{2}} is ready!", required: true },
          { key: "access_token", placeholder: "Bearer token", required: true },
        ],
      },
      {
        id: "create-template-advanced",
        label: "Create template (advanced)",
        method: "POST",
        path: `${API_URL}/auth/create-template`,
        description: "Create template with header, footer, buttons",
        bodyFields: [
          { key: "waba_id", placeholder: "123456789", required: true },
          { key: "template_name", placeholder: "promo_oct", required: true },
          { key: "language", placeholder: "en_US", required: true },
          { key: "category", placeholder: "MARKETING", required: true },
          { key: "body", placeholder: '{"text":"Hello {{1}}"}', required: true },
          { key: "footer", placeholder: '{"text":"Reply STOP to unsubscribe"}' },
        ],
      },
      {
        id: "delete-template",
        label: "Delete template",
        method: "DELETE",
        path: `${API_URL}/auth/template/delete`,
        description: "Delete a template from Meta and local DB",
        bodyFields: [
          { key: "name", placeholder: "my_template_name", required: true },
          { key: "waba_id", placeholder: "123456789", required: true },
          { key: "access_token", placeholder: "Bearer token", required: true },
        ],
      },
    ],
  },
  {
    group: "Send Messages",
    color: "#f59e0b",
    endpoints: [
      {
        id: "send-text",
        label: "Send text message",
        method: "POST",
        path: `${API_URL}/auth/send-message`,
        description: "Send a plain text WhatsApp message",
        bodyFields: [
          { key: "phone_number_id", placeholder: "1234567890", required: true },
          { key: "to", placeholder: "919876543210", required: true },
          { key: "message", placeholder: "Hello from GlobeWA!", required: true },
          { key: "access_token", placeholder: "Bearer token", required: true },
        ],
      },
      {
        id: "send-template-msg",
        label: "Send template message",
        method: "POST",
        path: `${API_URL}/auth/messages/send-template`,
        description: "Send an approved template message with variables",
        bodyFields: [
          { key: "phone_number_id", placeholder: "1234567890", required: true },
          { key: "to", placeholder: "919876543210", required: true },
          { key: "template_name", placeholder: "my_template_name", required: true },
          { key: "variables", placeholder: '["John","Order #1234"]' },
        ],
      },
    ],
  },
  {
    group: "WhatsApp Accounts",
    color: "#ec4899",
    endpoints: [
      {
        id: "my-whatsapp",
        label: "My WhatsApp accounts",
        method: "GET",
        path: `${API_URL}/auth/my-whatsapp`,
        description: "Fetch all connected WABA accounts for the logged-in user",
      },
      {
        id: "phone-numbers",
        label: "Phone numbers",
        method: "GET",
        path: `${API_URL}/auth/user/whatsapp-phone-numbers/:userId`,
        description: "Get all phone numbers for a user",
        paramFields: [{ key: "userId", placeholder: "42", autoFromToken: true }],
      },
      {
        id: "waba-phones",
        label: "WABA phone numbers (live)",
        method: "GET",
        path: `${API_URL}/auth/waba/:wabaId/phones`,
        description: "Fetch live phone numbers from Meta for a WABA",
        paramFields: [{ key: "wabaId", placeholder: "123456789" }],
      },
      {
        id: "waba-ids",
        label: "WABA IDs for user",
        method: "GET",
        path: `${API_URL}/auth/whatsapp/waba_ids`,
        description: "Get all WABA IDs associated with a user",
        queryFields: [{ key: "user_id", placeholder: "42", required: true, autoFromToken: true }],
      },
      {
        id: "message-limit",
        label: "Message limit",
        method: "GET",
        path: `${API_URL}/auth/message-limit`,
        description: "Check WhatsApp Business messaging tier limits",
        queryFields: [
          { key: "phone_number_id", placeholder: "1234567890", required: true },
          { key: "fbToken", placeholder: "Bearer token", required: true },
        ],
      },
    ],
  },
  {
    group: "Conversations",
    color: "#06b6d4",
    endpoints: [
      {
        id: "conversations",
        label: "List conversations",
        method: "GET",
        path: `${API_URL}/auth/conversation/:phoneNumberId`,
        description: "Get all conversation threads for a phone number",
        paramFields: [{ key: "phoneNumberId", placeholder: "1234567890" }],
      },
      {
        id: "messages",
        label: "Get messages",
        method: "GET",
        path: `${API_URL}/auth/messages/:phoneNumberId/:userNumber`,
        description: "Get message history for a specific conversation",
        paramFields: [
          { key: "phoneNumberId", placeholder: "1234567890" },
          { key: "userNumber", placeholder: "919876543210" },
        ],
      },
      {
        id: "window-status",
        label: "Window status",
        method: "GET",
        path: `${API_URL}/auth/window-status`,
        description: "Check if the 24hr messaging window is open",
        queryFields: [
          { key: "phone_number_id", placeholder: "1234567890", required: true },
          { key: "customer_number", placeholder: "919876543210", required: true },
        ],
      },
      {
        id: "mark-read",
        label: "Mark as read",
        method: "POST",
        path: `${API_URL}/auth/mark-read`,
        description: "Mark all messages from a number as read",
        bodyFields: [{ key: "userNumber", placeholder: "919876543210", required: true }],
      },
    ],
  },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────
const METHOD_COLORS = {
  GET: "#10b981",
  POST: "#6366f1",
  PUT: "#f59e0b",
  DELETE: "#ef4444",
};

function statusClass(code) {
  if (code >= 200 && code < 300) return "2xx";
  if (code >= 400 && code < 500) return "4xx";
  if (code >= 500) return "5xx";
  return "none";
}

function statusColor(cls) {
  return { "2xx": "#10b981", "4xx": "#f59e0b", "5xx": "#ef4444", pending: "#6366f1", none: "#6b7280" }[cls];
}

function buildUrl(path, params, query) {
  let url = path;
  for (const [k, v] of Object.entries(params)) {
    url = url.replace(`:${k}`, encodeURIComponent(v));
  }
  const qs = new URLSearchParams(
    Object.fromEntries(
      Object.entries(query).filter(([, v]) => v !== undefined && v !== null && v !== "")
    )
  ).toString();
  return qs ? `${url}?${qs}` : url;
}

// ─── Component ────────────────────────────────────────────────────────────────
export default function ApiPlayground() {
  const [selected, setSelected] = useState(GROUPS[0].endpoints[0]);
  const [bodyValues, setBodyValues] = useState({});
  const [queryValues, setQueryValues] = useState({});
  const [paramValues, setParamValues] = useState({});
  const [rawBody, setRawBody] = useState("");
  const [useRaw, setUseRaw] = useState(false);
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeResponseTab, setActiveResponseTab] = useState("body");
  const [history, setHistory] = useState([]);
  const [sidebarSearch, setSidebarSearch] = useState("");
  const [expandedGroups, setExpandedGroups] = useState(new Set(GROUPS.map(g => g.group)));

  // ── Auth state read from localStorage ──
  const [authInfo, setAuthInfo] = useState({ userId: null, token: null });

  // Read token on mount (and whenever localStorage changes)
  useEffect(() => {
    function readAuth() {
      const { userId, token } = getUserIdFromToken();
      setAuthInfo({ userId, token });
      // Re-seed auto-fill fields for the currently selected endpoint
      setBodyValues(prev => {
        const ep = GROUPS.flatMap(g => g.endpoints).find(e => e.id === selected.id) || selected;
        const next = { ...prev };
        (ep.bodyFields || []).forEach(f => { if (f.autoFromToken && userId) next[f.key] = String(userId); });
        return next;
      });
      setQueryValues(prev => {
        const ep = GROUPS.flatMap(g => g.endpoints).find(e => e.id === selected.id) || selected;
        const next = { ...prev };
        (ep.queryFields || []).forEach(f => { if (f.autoFromToken && userId) next[f.key] = String(userId); });
        return next;
      });
      setParamValues(prev => {
        const ep = GROUPS.flatMap(g => g.endpoints).find(e => e.id === selected.id) || selected;
        const next = { ...prev };
        (ep.paramFields || []).forEach(f => { if (f.autoFromToken && userId) next[f.key] = String(userId); });
        return next;
      });
    }
    readAuth();

    // Listen for storage events (cross-tab) and a custom event for same-tab updates
    window.addEventListener("storage", readAuth);
    window.addEventListener("authTokenChanged", readAuth);
    return () => {
      window.removeEventListener("storage", readAuth);
      window.removeEventListener("authTokenChanged", readAuth);
    };
  }, []);

  function buildAutoFill(ep, userId) {
    const fill = (fields) => {
      const vals = {};
      (fields || []).forEach(f => {
        if (f.autoFromToken && userId) vals[f.key] = String(userId);
      });
      return vals;
    };
    return {
      body: fill(ep.bodyFields),
      query: fill(ep.queryFields),
      param: fill(ep.paramFields),
    };
  }

  function selectEndpoint(ep) {
    setSelected(ep);
    const { body, query, param } = buildAutoFill(ep, authInfo.userId);
    setBodyValues(body);
    setQueryValues(query);
    setParamValues(param);
    setRawBody("");
    setResponse(null);
  }

  function toggleGroup(g) {
    setExpandedGroups(prev => {
      const next = new Set(prev);
      next.has(g) ? next.delete(g) : next.add(g);
      return next;
    });
  }

  const filteredGroups = GROUPS.map(g => ({
    ...g,
    endpoints: g.endpoints.filter(e =>
      e.label.toLowerCase().includes(sidebarSearch.toLowerCase()) ||
      e.path.toLowerCase().includes(sidebarSearch.toLowerCase())
    ),
  })).filter(g => g.endpoints.length > 0);

  async function send() {
    setLoading(true);
    setResponse(null);
    const start = Date.now();
    const url = buildUrl(selected.path, paramValues, queryValues);

    let body = undefined;
    if (selected.method !== "GET") {
      if (useRaw) {
        try { body = JSON.parse(rawBody); } catch { body = rawBody; }
      } else {
        body = Object.fromEntries(
          Object.entries(bodyValues).map(([k, v]) => {
            if (typeof v === "string") {
              try { return [k, JSON.parse(v)]; } catch { return [k, v]; }
            }
            return [k, v];
          })
        );
      }
    }

    // Build headers — always inject Authorization if token is present
    const headers = {};
    if (authInfo.token) {
      headers["Authorization"] = authInfo.token.startsWith("Bearer ")
        ? authInfo.token
        : `Bearer ${authInfo.token}`;
    }

    try {
      const res = await axios({
        method: selected.method.toLowerCase(),
        url,
        data: body,
        withCredentials: true,
        headers,
      });
      const latency = Date.now() - start;
      const resp = {
        status: res.status,
        statusText: res.statusText,
        data: res.data,
        latency,
        headers: res.headers,
      };
      setResponse(resp);
      setHistory(h => [
        { endpoint: selected.label, status: res.status, latency, time: new Date().toLocaleTimeString() },
        ...h.slice(0, 19),
      ]);
    } catch (err) {
      const latency = Date.now() - start;
      const errResp = err && err.response;
      const resp = {
        status: (errResp && errResp.status) ? errResp.status : 0,
        statusText: (errResp && errResp.statusText) || "Network Error",
        data: (errResp && errResp.data) || { error: (err && err.message) || "Unknown error" },
        latency,
        headers: (errResp && errResp.headers) || {},
      };
      setResponse(resp);
      setHistory(h => [
        { endpoint: selected.label, status: resp.status, latency, time: new Date().toLocaleTimeString() },
        ...h.slice(0, 19),
      ]);
    }
    setLoading(false);
  }

  const resolvedUrl = buildUrl(selected.path, paramValues, queryValues);

  return (
    <div style={{ display: "flex", height: "100vh", background: "#0a0a0f", fontFamily: "'JetBrains Mono', 'Fira Code', monospace", color: "#e2e8f0", overflow: "hidden" }}>

      {/* ── Sidebar ── */}
      <div style={{ width: 280, background: "#0f0f1a", borderRight: "1px solid #1e1e2e", display: "flex", flexDirection: "column", flexShrink: 0 }}>
        <div style={{ padding: "16px 12px 12px", borderBottom: "1px solid #1e1e2e" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#6366f1" }} />
            <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: "0.05em", color: "#a5b4fc" }}>API PLAYGROUND</span>
          </div>
          <input
            value={sidebarSearch}
            onChange={e => setSidebarSearch(e.target.value)}
            placeholder="Search endpoints..."
            style={{ width: "100%", background: "#1a1a2e", border: "1px solid #2a2a3e", borderRadius: 6, padding: "6px 10px", fontSize: 12, color: "#e2e8f0", outline: "none", boxSizing: "border-box" }}
          />
        </div>

        <div style={{ flex: 1, overflowY: "auto", padding: "8px 0" }}>
          {filteredGroups.map(g => (
            <div key={g.group}>
              <button
                onClick={() => toggleGroup(g.group)}
                style={{ width: "100%", display: "flex", alignItems: "center", gap: 8, padding: "6px 12px", background: "none", border: "none", cursor: "pointer", color: "#94a3b8", fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", fontFamily: "inherit" }}
              >
                <div style={{ width: 6, height: 6, borderRadius: "50%", background: g.color, flexShrink: 0 }} />
                {g.group}
                <span style={{ marginLeft: "auto", fontSize: 10 }}>{expandedGroups.has(g.group) ? "▾" : "▸"}</span>
              </button>
              {expandedGroups.has(g.group) && g.endpoints.map(ep => (
                <button
                  key={ep.id}
                  onClick={() => selectEndpoint(ep)}
                  style={{
                    width: "100%", display: "flex", alignItems: "center", gap: 8, padding: "7px 12px 7px 24px",
                    background: selected.id === ep.id ? "#1a1a2e" : "none",
                    border: "none", borderLeft: selected.id === ep.id ? `2px solid ${g.color}` : "2px solid transparent",
                    cursor: "pointer", fontFamily: "inherit",
                  }}
                >
                  <span style={{ fontSize: 10, fontWeight: 700, color: METHOD_COLORS[ep.method], minWidth: 36, textAlign: "left" }}>{ep.method}</span>
                  <span style={{ fontSize: 11, color: selected.id === ep.id ? "#e2e8f0" : "#94a3b8", textAlign: "left", lineHeight: 1.3 }}>{ep.label}</span>
                </button>
              ))}
            </div>
          ))}
        </div>

        {/* History */}
        {history.length > 0 && (
          <div style={{ borderTop: "1px solid #1e1e2e", padding: "8px 0" }}>
            <div style={{ padding: "4px 12px 6px", fontSize: 10, fontWeight: 700, color: "#64748b", letterSpacing: "0.08em", textTransform: "uppercase" }}>Recent</div>
            {history.slice(0, 5).map((h, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 12px", fontSize: 10, color: "#64748b" }}>
                <span style={{ color: statusColor(statusClass(h.status)), fontWeight: 700 }}>{h.status || "ERR"}</span>
                <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{h.endpoint}</span>
                <span style={{ color: "#475569" }}>{h.latency}ms</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ── Main ── */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>

        {/* URL bar */}
        <div style={{ padding: "12px 16px", borderBottom: "1px solid #1e1e2e", background: "#0c0c17" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
            <span style={{ fontSize: 11, color: "#64748b" }}>{selected.description}</span>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <div style={{ display: "flex", alignItems: "center", padding: "0 12px", background: "#1a1a2e", borderRadius: 8, border: "1px solid #2a2a3e", height: 40, minWidth: 80 }}>
              <span style={{ fontSize: 12, fontWeight: 800, color: METHOD_COLORS[selected.method] }}>{selected.method}</span>
            </div>
            <div style={{ flex: 1, display: "flex", alignItems: "center", background: "#1a1a2e", borderRadius: 8, border: "1px solid #2a2a3e", padding: "0 12px", height: 40, overflow: "hidden" }}>
              <span style={{ fontSize: 12, color: "#64748b", whiteSpace: "nowrap" }}>localhost /</span>
              <span style={{ fontSize: 12, color: "#a5b4fc", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{resolvedUrl}</span>
            </div>
            <button
              onClick={send} disabled={loading}
              style={{ padding: "0 24px", height: 40, background: loading ? "#3730a3" : "#4f46e5", color: "white", border: "none", borderRadius: 8, cursor: loading ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 700, fontFamily: "inherit", display: "flex", alignItems: "center", gap: 8, transition: "background 0.15s" }}
            >
              {loading ? (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ animation: "spin 0.8s linear infinite" }}><path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0"/></svg>
              ) : (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M5 3l14 9-14 9V3z"/></svg>
              )}
              {loading ? "Sending..." : "Send"}
            </button>
          </div>

          {/* ── Auth status bar (read-only, from localStorage) ── */}
          <div style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 10, padding: "6px 10px", background: "#0f0f1a", borderRadius: 6, border: "1px solid #1e1e2e" }}>
            {authInfo.token ? (
              <>
                <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#10b981", flexShrink: 0 }} />
                <span style={{ fontSize: 11, color: "#10b981", fontWeight: 600 }}>Authenticated</span>
                {authInfo.userId && (
                  <span style={{ fontSize: 11, color: "#64748b" }}>
                    · user_id: <span style={{ color: "#a5b4fc" }}>{authInfo.userId}</span>
                  </span>
                )}
                <span style={{ fontSize: 11, color: "#334155", marginLeft: "auto", fontFamily: "inherit" }}>
                  {authInfo.token.replace(/^Bearer\s*/i, "").slice(0, 24)}…
                </span>
              </>
            ) : (
              <>
                <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#ef4444", flexShrink: 0 }} />
                <span style={{ fontSize: 11, color: "#ef4444", fontWeight: 600 }}>No token found</span>
                <span style={{ fontSize: 11, color: "#475569", marginLeft: 4 }}>— set <code style={{ color: "#a5b4fc" }}>token</code> in localStorage to authenticate</span>
              </>
            )}
          </div>
        </div>

        {/* Request / Response panels */}
        <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>

          {/* Request */}
          <div style={{ width: "45%", borderRight: "1px solid #1e1e2e", display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <div style={{ padding: "10px 16px", borderBottom: "1px solid #1e1e2e", display: "flex", alignItems: "center", gap: 12 }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.06em" }}>REQUEST</span>
              {selected.method !== "GET" && (
                <div style={{ display: "flex", gap: 4, marginLeft: "auto" }}>
                  {["Form", "Raw JSON"].map(t => (
                    <button key={t} onClick={() => setUseRaw(t === "Raw JSON")}
                      style={{ padding: "2px 10px", fontSize: 10, fontWeight: 600, background: (t === "Raw JSON") === useRaw ? "#1e1e2e" : "none", color: (t === "Raw JSON") === useRaw ? "#a5b4fc" : "#475569", border: "1px solid", borderColor: (t === "Raw JSON") === useRaw ? "#3730a3" : "transparent", borderRadius: 4, cursor: "pointer", fontFamily: "inherit" }}>
                      {t}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <div style={{ flex: 1, overflowY: "auto", padding: 16 }}>

              {/* Path params */}
              {selected.paramFields && selected.paramFields.length > 0 && (
                <Section label="PATH PARAMS" color="#f59e0b">
                  {selected.paramFields.map(f => (
                    <Field key={f.key} label={f.key} placeholder={f.placeholder} autoFromToken={f.autoFromToken}
                      value={paramValues[f.key] || ""} onChange={v => setParamValues(p => ({ ...p, [f.key]: v }))} />
                  ))}
                </Section>
              )}

              {/* Query params */}
              {selected.queryFields && selected.queryFields.length > 0 && (
                <Section label="QUERY PARAMS" color="#06b6d4">
                  {selected.queryFields.map(f => (
                    <Field key={f.key} label={f.key} placeholder={f.placeholder} required={f.required} autoFromToken={f.autoFromToken}
                      value={queryValues[f.key] || ""} onChange={v => setQueryValues(p => ({ ...p, [f.key]: v }))} />
                  ))}
                </Section>
              )}

              {/* Body */}
              {selected.method !== "GET" && (
                <Section label="BODY" color="#10b981">
                  {useRaw ? (
                    <textarea
                      value={rawBody}
                      onChange={e => setRawBody(e.target.value)}
                      placeholder='{"key": "value"}'
                      rows={12}
                      style={{ width: "100%", background: "#0f0f1a", border: "1px solid #1e1e2e", borderRadius: 6, padding: "10px 12px", fontSize: 12, color: "#a5b4fc", fontFamily: "inherit", resize: "vertical", outline: "none", boxSizing: "border-box" }}
                    />
                  ) : (
                    selected.bodyFields && selected.bodyFields.map(f => (
                      <Field key={f.key} label={f.key} placeholder={f.placeholder} required={f.required} type={f.type} autoFromToken={f.autoFromToken}
                        value={bodyValues[f.key] || ""} onChange={v => setBodyValues(p => ({ ...p, [f.key]: v }))} />
                    ))
                  )}
                </Section>
              )}

              {(!selected.paramFields || !selected.paramFields.length) && (!selected.queryFields || !selected.queryFields.length) && selected.method === "GET" && (
                <div style={{ color: "#475569", fontSize: 12, padding: "40px 0", textAlign: "center" }}>No parameters required</div>
              )}
            </div>
          </div>

          {/* Response */}
          <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <div style={{ padding: "10px 16px", borderBottom: "1px solid #1e1e2e", display: "flex", alignItems: "center", gap: 12 }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.06em" }}>RESPONSE</span>
              {response && (
                <>
                  <span style={{ padding: "2px 8px", borderRadius: 4, fontSize: 11, fontWeight: 700, background: statusColor(statusClass(response.status)) + "22", color: statusColor(statusClass(response.status)), border: `1px solid ${statusColor(statusClass(response.status))}44` }}>
                    {response.status} {response.statusText}
                  </span>
                  <span style={{ fontSize: 11, color: "#475569" }}>{response.latency}ms</span>
                  <div style={{ display: "flex", gap: 4, marginLeft: "auto" }}>
                    {["body", "headers"].map(t => (
                      <button key={t} onClick={() => setActiveResponseTab(t)}
                        style={{ padding: "2px 10px", fontSize: 10, fontWeight: 600, background: activeResponseTab === t ? "#1e1e2e" : "none", color: activeResponseTab === t ? "#a5b4fc" : "#475569", border: "1px solid", borderColor: activeResponseTab === t ? "#3730a3" : "transparent", borderRadius: 4, cursor: "pointer", fontFamily: "inherit", textTransform: "capitalize" }}>
                        {t}
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>

            <div style={{ flex: 1, overflowY: "auto", padding: 16 }}>
              {loading && (
                <div style={{ display: "flex", alignItems: "center", gap: 12, color: "#475569", padding: "40px 0" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2.5" style={{ animation: "spin 0.8s linear infinite" }}><path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0"/></svg>
                  <span style={{ fontSize: 13 }}>Waiting for response...</span>
                </div>
              )}
              {!loading && !response && (
                <div style={{ color: "#334155", fontSize: 13, padding: "60px 0", textAlign: "center" }}>
                  <div style={{ fontSize: 32, marginBottom: 12 }}>⚡</div>
                  Hit Send to see the response
                </div>
              )}
              {!loading && response && (
                activeResponseTab === "body" ? (
                  <pre style={{ fontSize: 12, color: "#a5b4fc", lineHeight: 1.6, margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
                    {JSON.stringify(response.data, null, 2)}
                  </pre>
                ) : (
                  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    {Object.entries(response.headers).map(([k, v]) => (
                      <div key={k} style={{ display: "flex", gap: 12, fontSize: 12 }}>
                        <span style={{ color: "#6366f1", minWidth: 180 }}>{k}</span>
                        <span style={{ color: "#94a3b8" }}>{String(v)}</span>
                      </div>
                    ))}
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        ::-webkit-scrollbar { width: 4px; height: 4px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: #1e1e2e; border-radius: 4px; }
      `}</style>
    </div>
  );
}

// ─── Sub-components ───────────────────────────────────────────────────────────
function Section({ label, color, children }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 10 }}>
        <div style={{ width: 3, height: 12, background: color, borderRadius: 2 }} />
        <span style={{ fontSize: 10, fontWeight: 700, color: "#64748b", letterSpacing: "0.08em" }}>{label}</span>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>{children}</div>
    </div>
  );
}

function Field({ label, placeholder, value, onChange, required, type, autoFromToken }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div style={{ width: 140, flexShrink: 0, display: "flex", alignItems: "center", gap: 4 }}>
        <span style={{ fontSize: 11, color: "#94a3b8", fontFamily: "inherit" }}>{label}</span>
        {required && !autoFromToken && <span style={{ fontSize: 10, color: "#ef4444" }}>*</span>}
      </div>
      {autoFromToken ? (
        <div style={{ flex: 1, display: "flex", alignItems: "center", gap: 6, background: "#0f0f1a", border: "1px solid #1e1e2e", borderRadius: 6, padding: "6px 10px", opacity: 0.85 }}>
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          <span style={{ fontSize: 12, color: "#a5b4fc", fontFamily: "inherit" }}>{value || "—"}</span>
          <span style={{ fontSize: 10, color: "#3730a3", marginLeft: "auto", letterSpacing: "0.04em" }}>from token</span>
        </div>
      ) : (
        <input
          type={type || "text"}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          style={{ flex: 1, background: "#0f0f1a", border: "1px solid #1e1e2e", borderRadius: 6, padding: "6px 10px", fontSize: 12, color: "#e2e8f0", fontFamily: "inherit", outline: "none", transition: "border-color 0.15s" }}
          onFocus={e => (e.target.style.borderColor = "#3730a3")}
          onBlur={e => (e.target.style.borderColor = "#1e1e2e")}
        />
      )}
    </div>
  );
}